import React, {Component, useEffect, useState} from 'react';
import './ConfirmAccount.css';
import { FaUserAlt, FaLock, FaEnvelope, FaUserLock, FaUserTie, FaUniversity } from "react-icons/fa";
import back from '../../assets/Group 1.svg';
import queryString from 'query-string'

import { useMutation } from '@apollo/client';
import { CONFIRM_ACCOUNT } from '../../queries'

const ConfirmAccount = (props) => {
    const values = queryString.parse(props.location.search)
    const [ ConfirmAccount, { data, loading, error }] = useMutation(CONFIRM_ACCOUNT);

    const [errorLog, setErrorLog] = useState('');
    useEffect(()=>{
        console.log(error)
        if(error) {
            setErrorLog(error.message);
        }
    }, [error]);

  return (
    <ConfirmAccountForm errorLog={errorLog}  token={values.token} ConfirmAccount={ConfirmAccount} loading={loading}/>
  )
}


class ConfirmAccountForm extends Component{
    constructor(props) {
        super(props);
        this.state = {
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }


    handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
          [name]: value
        });
    }

    async handleSubmit() {
        
        if (1){
            const o = { variables: {
                token: this.props.token,
              }};
      
      
              try {
                await this.props.ConfirmAccount(o);
                alert("Konfirmasi Berhasil! :)")
                window.location = '/signin';
              }
                  catch (e) {
                      alert("Konfirmasi Gagal! Silahkan hubungi admin melalui instagram!");
              }
        }
    }

    componentDidMount(){
        this.handleSubmit();
    }

    render() {
        return (
            <></>
        )
    }
}

export default ConfirmAccount;
